<template>
  <div>
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <v-row class="graphic-space">
      <v-col v-if="showPaymentStatusGraphic" cols="12" sm="6" md="4">
        <apexchart :height="300" type="donut" :options="chartPaymentStatus" :series="dataPaymentStatus"></apexchart>
      </v-col>
      <v-col v-if="showStatusGraphic" cols="12" sm="6" md="4">
        <apexchart :height="300" type="donut" :options="chartStatus" :series="dataStatus"></apexchart>
      </v-col>
      <v-col v-if="showTypeBuysGraphic" cols="12" sm="6" md="4">
        <apexchart :height="300" type="donut" :options="chartBuys" :series="dataBuys"></apexchart>
      </v-col>
      <v-col v-if="showPaymentConditionalGraphic" cols="12" sm="6" md="4">
        <apexchart :height="300" type="donut" :options="chartPaymentConditional" :series="dataPaymentConditional"></apexchart>
      </v-col>
      <v-col v-if="showNumberLotsGraphic" cols="12" sm="6" md="4">
        <apexchart :height="300" type="donut" :options="chartNumberLots" :series="dataNumberLots"></apexchart>
      </v-col>
      <v-col v-if="showSizeLotsGraphic" cols="12" sm="6" md="4">
        <apexchart :height="300" type="donut" :options="chartSizeLots" :series="dataSizeLots"></apexchart>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import apexchart from 'vue-apexcharts'
import DialogLoading from '@/components/loading/DialogLoading'
import message from '@/utils/message'
import api from '@/services/api'

export default {
  components: {
    apexchart: apexchart,
    DialogLoading
  },

  data: () => ({
    showTypeBuysGraphic: false,
    showNumberLotsGraphic: false,
    showSizeLotsGraphic: false,
    showPaymentConditionalGraphic: false,
    showPaymentStatusGraphic: false,
    showStatusGraphic: false,
    loading: true,
    loadingMessage: 'Carregando',
    dataBuys: [],
    dataNumberLots: [],
    dataSizeLots: [],
    dataPaymentConditional: [],
    dataPaymentStatus: [],
    dataStatus: [],
    chartBuys: {},
    chartNumberLots: {},
    chartSizeLots: {},
    chartPaymentConditional: {},
    chartPaymentStatus: {},
    chartStatus: {},
    chartOptionsDefault: {
      chart: {
        type: 'donut'
      },
      title: {
        text: null,
        align: 'center'
      },
      dataLabels: {
        enabled: true
      },
      labels: [],
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 90,
          offsetY: 10
        }
      },
      grid: {
        padding: {
          bottom: -80
        }
      },
      legend: {
        position: 'top',
        offsetY: 20
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 300
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    }
  }),
  created () {
    this.chartBuys = JSON.parse(JSON.stringify(this.chartOptionsDefault))
    this.chartNumberLots = JSON.parse(JSON.stringify(this.chartOptionsDefault))
    this.chartPaymentConditional = JSON.parse(JSON.stringify(this.chartOptionsDefault))
    this.chartPaymentStatus = JSON.parse(JSON.stringify(this.chartOptionsDefault))
    this.chartStatus = JSON.parse(JSON.stringify(this.chartOptionsDefault))
    this.chartSizeLots = JSON.parse(JSON.stringify(this.chartOptionsDefault))
    this.getTypeBuysInfo()
    this.getNumberLotsInfo()
    this.getSizeLotsInfo()
    this.getPaymentConditionalInfo()
    this.getPaymentStatusInfo()
    this.getStatusInfo()
  },

  methods: {
    async getTypeBuysInfo () {
      try {
        this.loading = true
        this.chartBuys.title.text = 'Tipo de Compra'
        const { data } = await api.get('/type-buys-infos')
        data.forEach(info => {
          this.chartBuys.labels.push(info.name)
          this.dataBuys.push(info.total)
        })
        this.showTypeBuysGraphic = true
      } catch (error) {
        message.error('Erro ao buscar dados do gráfico de tipo de compra')
      } finally {
        this.loading = false
      }
    },
    async getNumberLotsInfo () {
      try {
        this.loading = true
        this.chartNumberLots.title.text = 'Quantidade de Lotes'
        const { data } = await api.get('/number-lots-infos')
        data.forEach(info => {
          this.chartNumberLots.labels.push(info.name)
          this.dataNumberLots.push(info.total)
        })
        this.showNumberLotsGraphic = true
      } catch (error) {
        message.error('Erro ao buscar dados do gráfico de quantidade de lotes')
      } finally {
        this.loading = false
      }
    },
    async getPaymentConditionalInfo () {
      try {
        this.loading = true
        this.chartPaymentConditional.title.text = 'Pagamento'
        const { data } = await api.get('/payment-conditionals-infos')
        data.forEach(info => {
          this.chartPaymentConditional.labels.push(info.name)
          this.dataPaymentConditional.push(info.total)
        })
        this.showPaymentConditionalGraphic = true
      } catch (error) {
        message.error('Erro ao buscar dados do gráfico de condição de pagamento')
      } finally {
        this.loading = false
      }
    },
    async getPaymentStatusInfo () {
      try {
        this.loading = true
        this.chartPaymentStatus.title.text = 'Status Financeiro'
        const { data } = await api.get('/payment-statuses-infos')
        data.forEach(info => {
          this.chartPaymentStatus.labels.push(info.name)
          this.dataPaymentStatus.push(info.total)
        })
        this.showPaymentStatusGraphic = true
      } catch (error) {
        message.error('Erro ao buscar dados do gráfico de status de pagamento')
      } finally {
        this.loading = false
      }
    },
    async getStatusInfo () {
      try {
        this.loading = true
        this.chartStatus.title.text = 'Status'
        const { data } = await api.get('/statuses-infos')
        data.forEach(info => {
          this.chartStatus.labels.push(info.name)
          this.dataStatus.push(info.total)
        })
        this.showStatusGraphic = true
      } catch (error) {
        message.error('Erro ao buscar dados do gráfico de status')
      } finally {
        this.loading = false
      }
    },
    async getSizeLotsInfo () {
      try {
        this.loading = true
        this.chartSizeLots.title.text = 'Tamanho dos Lotes'
        const { data } = await api.get('/size-lots-infos')
        data.forEach(info => {
          this.chartSizeLots.labels.push(info.name)
          this.dataSizeLots.push(info.total)
        })
        this.showSizeLotsGraphic = true
      } catch (error) {
        message.error('Erro ao buscar dados do gráfico de tamanho de lotes')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dashboards/ReserveInfos.vue